import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useTenant } from "@/contexts/TenantContext";

const STATUS_STYLE = {
  Healthy: { color: "#10B981", label: "HEALTHY" },
  Degraded: { color: "#F59E0B", label: "DEGRADED" },
  Offline: { color: "#EF4444", label: "OFFLINE" },
};

function timeAgo(iso) {
  const m = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
  if (m < 1) return "now";
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}

export default function FirewallsList() {
  const { tenant } = useTenant();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!tenant) return;
    api.get(`/soc/firewalls?tenant=${tenant.id}`).then(({ data }) => setItems(data));
  }, [tenant]);

  return (
    <div className="overflow-y-auto max-h-[400px]" data-testid="firewalls-list">
      <table className="w-full text-sm">
        <thead className="sticky top-0 bg-[#0F172A]">
          <tr className="text-[10px] uppercase font-mono text-slate-500 border-b border-slate-800">
            <th className="text-left px-5 py-3">Firewall</th>
            <th className="text-left px-5 py-3">Model</th>
            <th className="text-center px-5 py-3">Status</th>
            <th className="text-right px-5 py-3">Uptime</th>
            <th className="text-right px-5 py-3 pr-6">Policy</th>
          </tr>
        </thead>
        <tbody>
          {items.map((f) => {
            const s = STATUS_STYLE[f.status] || STATUS_STYLE.Healthy;
            return (
              <tr key={f.id} className="border-b border-slate-800/40 hover:bg-[#1E293B]/40" data-testid={`firewall-row-${f.id}`}>
                <td className="px-5 py-2.5">
                  <div className="text-slate-100 text-xs font-semibold">{f.unit_name}</div>
                  <div className="text-[9px] font-mono text-slate-500">{f.hostname}</div>
                </td>
                <td className="px-5 py-2.5 text-[11px] font-mono text-slate-400">{f.model}</td>
                <td className="px-5 py-2.5 text-center">
                  <span
                    className="text-[10px] font-mono font-bold px-2 py-0.5 border rounded-sm whitespace-nowrap"
                    style={{ color: s.color, borderColor: s.color + "55", background: s.color + "12" }}
                  >
                    ● {s.label}
                  </span>
                </td>
                <td className="px-5 py-2.5 text-right font-mono text-xs">
                  {f.uptime_days > 0 ? (
                    <>
                      <span className="text-slate-200">{f.uptime_days}d</span>
                      <div className="text-[9px] text-slate-500">sync {timeAgo(f.last_sync)}</div>
                    </>
                  ) : (
                    <span className="text-red-400">—</span>
                  )}
                </td>
                <td className="px-5 py-2.5 text-right pr-6 font-mono text-xs text-[#60A5FA]">{f.policy_version}</td>
              </tr>
            );
          })}
          {!items.length && <tr><td colSpan={5} className="px-5 py-10 text-center text-xs text-slate-500 font-mono">Loading firewalls...</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
